<template>
	<!-- star -->

	<div class="youjiaopage_wrap">
		<nav2></nav2>
		<banner2 :bannerH="h1" :bannerP="p1" :bannerImg="Img1"></banner2>
		<!-- 面包屑 -->
		<div class="Crumbs">
			<div>当前位置：首页><span>联系我们</span></div>
		</div>
		<!-- 上部分 -->
		<div class="talk_top">
			<div class="talk_top_cont">
				
				<div class="talk_top_cont_c">
					<h3>联系我们</h3>
					<div class="talk_top_cont_c_t">
						<div class="talk_top_cont_c_t_l">
							<p>公司地址：江西省南昌市赣江中大道1218号新地中心39层3908室</p>
							<p>热线电话：0791-88866416</p>
							<p>联系手机：18679829877（陶总）</p>
							<p>技术支持：18718687482（李总）</p>
							<p>联系邮箱：jxznpower@163.com</p>
						</div>
						
					</div>
				</div>
				<div class="talk_top_cont_r">
					<h3>扫码联系</h3>
					<div class="code-view">
						<div>
							<img src="../assets/img/ewm.jpg" alt="" />
							<p>微信咨询</p>
						</div>
						<div>
							<img src="../assets/img/ewm.jpg" alt="" />
							<p>微信咨询</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 下部分 -->
		<div class="talk_bottom">
			
				<baidu-map class="baiduMap" ref="bmap"
				  :center="bdCenter" :zoom="bdZoom"
				  :scroll-wheel-zoom="true"
				  :dragging="bdscrollWheelZoom"
				  :auto-resize="true"
				  @ready="handleMapReady"
				  @moving="syncCenterAndZoom"
				  @moveend="syncCenterAndZoom"
				  @zoomend="syncCenterAndZoom">
				  <bm-marker
					:position="bdCenter"
					:dragging="true"
					@click="infoWindowOpen"
					:animation="bdAnimation">
					<!-- <bm-label
					  :labelStyle="bdLabelStyle"
					  :content="bdContent"
					  :offset="bdOffset"/> -->
					  <bm-info-window
						:show="bmInfoWindow"
						@close="infoWindowClose"
						@open="infoWindowOpen">
					   <p style="color: red; font-size: 16px; margin-bottom: 10px">江西正能智慧科技有限公司</p>
					   <p style="color: #777777; font-size: 14px; line-height: 25px; margin-bottom: 5px;">联系方式：0791-88866416</p>
					   <p style="color: #777777; font-size: 14px; line-height: 25px;">公司地址：江西省南昌市赣江中大道1218号新地中心39层3908室</p>
					  </bm-info-window>
				  </bm-marker>
				  <bm-navigation :anchor="bdAnchorRight" />
				  <!-- <bm-map-type
					:map-types="bdBmmapTypes"
					:anchor="bdTypesBnchor" /> -->
				  <bm-geolocation
					:anchor="bdBottomBnchor"
					:showAddressBar="true"
					:autoLocation="true" />
				  <!-- <bm-scale :anchor="bdAnchorRight"></bm-scale> -->
				</baidu-map>
		</div>
		<div class="onlineMessage" id="m6">
            <a name="about-6" class="index-link"></a>
            <div class="main-center w-body">
                <div class="com-title">
                    <h3>在线留言
                        <p>ONLINE MESSAGE</p>
                    </h3>
                </div>
                <form action="/message/" method="post">
                    <div class="form-t fx ac jsb">
                        
                        <input type="text" name="contacts" placeholder="您的姓名*" required="" lay-verify="required">
                        <input type="tel" name="mobile" placeholder="您的电话*">
                    </div>
                    <textarea name="content" id="" placeholder="留言内容"></textarea>
                    <div class="btn"><button type="submit">立即提交</button></div>
                </form>
            </div>
        </div>

		<!-- end -->
	</div>
</template>

<script>
import banner2 from "../components/banner.vue";
import nav2 from "../components/nav.vue";
export default {
	name: "keji",
	components: {
		nav2,
		banner2,
	},
	data() {
		return {
			h1: "联系我们",
			Img1: require("../assets/banner/lianxiwomen.jpg"),
			p1: "真诚合作，诚信对待",
			bdCenter: { lng: 115.870294, lat: 28.692559 },
			bdZoom: 18, //缩放等级设置
			bdContent:'123',
			bdLabelStyle: {
				color: 'black',
				borderRadius:'5px',
				borderColor: '#ccc',
				fontSize : '12px',
				height:'30px',
				padding: '10px',
				fontFamily:'苹方'
			},
			bdOffset: {width: -35, height: 30},
			bdscrollWheelZoom:true, //鼠标缩放
			bdDragging:true, //可拖拽
			bdAnchorRight:'BMAP_ANCHOR_TOP_RIGHT', //缩放
			bdBmmapTypes:['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP'], //查看地图类型添加
			bdTypesBnchor:"BMAP_ANCHOR_TOP_LEFT",
			bdBottomBnchor:"BMAP_ANCHOR_BOTTOM_RIGHT",
			bdAnimation:"BMAP_ANIMATION_BOUNCE",
			bmInfoWindow:false,
			mapWidth:document.documentElement.clientWidth/2
		};
	},
	mounted(){
		window.onresize = ()=>{
			this.mapWidth = document.documentElement.clientWidth/2
		}
	},
	methods: {
		handleMapReady({BMap, map}) {
			console.log(BMap, map)
			// 经度
			this.bdCenter.lng = 115.870294
			// 纬度
			this.bdCenter.lat = 28.692559
			this.bdZoom = 18
			map.panBy(10, 5)
			// this.$nextTick(()=>{
			//   map.centerAndZoom(new BMap.Point("118.437543","31.361521"), 15);
			// })
			map.enableScrollWheelZoom(true);//开启鼠标滚轮缩放
		},
		syncCenterAndZoom (e) {
			// const {lng, lat} = e.target.getCenter()
			this.bdCenter.lng = 115.870294
			this.bdCenter.lat = 28.692559
			this.bdZoom = e.target.getZoom()
		},
		infoWindowClose () {
			this.bmInfoWindow = false
		},
		infoWindowOpen () {
			this.bmInfoWindow = true
		}
	},
};
</script>
<style scoped>
 /* 必须设定高度 */
 .baiduMap,.map{
    width: 100%;
    height: 500px; 
  }

.youjiaopage_wrap {
	width: 100vw;
	margin: 0 auto;
	height: auto;
	background: url('../assets/img/about-qyfc-bg@3x.png') no-repeat center;
    background-size: cover;
}
/* 面包屑 */
.Crumbs {
	width: 1400px;
	height: 46px;
	margin: 0 auto;
}
.Crumbs {
	font-size: 12px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #6c757d;
	line-height: 17px;
}
.Crumbs div {
	line-height: 46px;
}
.Crumbs span {
	color: #bfbfbf;
}
/* 联系我们 */

.talk_top_cont {
	display: flex;
	justify-content: space-between;
	width: 1400px;
	padding-top: 50px;
	margin: 0 auto;
}
.talk_top_cont_l {
	width: 235px;
	height: 134px;
}
.talk_top_cont_l > h1 {
	font-size: 32px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #23337f;
	line-height: 45px;
}
.talk_top_cont_l p {
	width: 235px;
	height: 80px;
	font-size: 48px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #f6f6f6;
	line-height: 40px;
}
.talk_top_cont_c {
	width: 900px;
	background-color: rgba(247,247,247,1);
	padding: 30px
}
.talk_top_cont_c h3{
	line-height: 30px;
    font-size: 20px;
    font-weight: bold;
    color: #0096a3;
    padding-bottom: 20px;
}
.talk_top_cont_c {
	font-size: 18px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #444444;
	line-height: 25px;
}

.talk_top_cont_c_t_l {
	font-size: 14px;
    line-height: 2;
    color: #777777;
}
.talk_top_cont_c_t_l p{
	font-size: 14px;
    line-height: 30px;
	margin-bottom: 10px
}
.talk_top_cont_r {
	flex: 1;
	margin-left: 20px;
	background-color: rgba(247,247,247,1);
	padding: 30px;
}
.code-view{
	display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
    margin-top: 30px;
}
.code-view div{
	padding: 0 20px;
}
.code-view div p{
	color: #777777;
	line-height: 30px;
	margin-top: 10px;
	text-align: center;
	font-size: 14px;
}
.talk_top_cont_r h3{
	line-height: 30px;
    font-size: 20px;
    font-weight: bold;
    color: #0096a3;
    padding-bottom: 20px;
}
.talk_top_cont_r img {
	border: 1px solid #ededed;
	width: 150px;
	height: 150px;
}
.talk_top_cont_c_t_r {
	margin-top: 36px;
}
.talk_top_cont_c_b_r {
	margin-top: 36px;
}
.talk_bottom {
	width: 1400px;
	margin: 50px auto;
	margin-bottom: 81px;
}
.talk_bottom .ueditor_baidumap{
	width: 100%;
}
.talk_bottom img{
	width: 100%
}
.onlineMessage{
	width: 100vw;
    height: 700px;
    background: url('../assets/img/mb_img.png') no-repeat center;
	background-size: cover;
}
.onlineMessage form .form-t {
    margin-bottom: 20px;
}
.onlineMessage form .form-t input {
    width: 48%;
    height: 48px;
    padding: 0 20px;
    background-color: #fff;
    box-sizing: border-box;
    border: 1px solid #e5e5e5;
}
.onlineMessage form textarea {
    width: 100%;
    height: 100px;
    padding: 20px;
    margin-bottom: 20px;
    background-color: #fff;
    resize: none;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
	font-size: 14px
}
.onlineMessage form .btn {
    text-align: center;
}
.onlineMessage form button {
    height: 48px;
    width: 200px;
    text-align: center;
    line-height: 48px;
    background-color: #0096a3;
    color: #fff;
    border: 0;
    outline: none;
    cursor: pointer;
}
.onlineMessage form button:hover{
	background-color: #4CCE9D;
}
</style>
